module.exports = __webpack_public_path__ + "media/images/dashboard/tile_icon_default-0b068371730fe5f43395791535babe6e.png";